import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Countdown = lazy(() => import("@/public/Countdown"));
const OPEN_PATHS = ["/login", "/forgot-password", "/reset-password", "/privacy", "/privacy-policy", "/fan-terms", "/dpa", "/terms", "/cookies", "/my-data", "/pricing", "/referral-terms"];
const isOpenPath = (p) => OPEN_PATHS.includes(p) || p.startsWith("/unsubscribe/");

export const useSite = () => useQuery({ queryKey: ["site"], queryFn: () => api.get("/site").then((r) => r.data), staleTime: 30000 });

export const LaunchGate = ({ children }) => {
  const { data: site } = useSite();
  const { user } = useAuth();
  const { pathname, hash } = useLocation();
  if (site?.launched || isOpenPath(pathname) || hash?.includes("session_id=")) return children;
  if (!site || user === null) return <div className="min-h-screen bg-background" />;
  if (user?.is_admin) return children;
  return <Suspense fallback={<div className="min-h-screen bg-[#0b0c12]" />}><Countdown launchAt={site.launch_at} /></Suspense>;
};
